import "./assets/App.css";
import HomePage from "./pages/Home/index";

function App() {
  return (
    <div className="App">
      <HomePage />
    </div>
  );
}

export default App;
